import VisaBookInterator from 'Domain/use-cases/visa-book-interactor'
import { formatDate } from 'Utils/dateUtil'

const initialState = () => {
  return {
    ConsularList: [], // 领区下拉菜单控件数据
    continentId: '', // 本地洲区id
    continent: '',
    countryId: '', // 国家id
    country: '',
    consularDistrictName: '',
    consularDistId: '',
    tripDate: formatDate(new Date(), 30).date, // 出行日期
    VisaDetail: {} // 选择的签证信息
  }
}

const visa = {
  namespaced: true,
  state: {
    visaSearchInfo: initialState(),
    travelerList: []
  },
  getters: { //getters属性理解为所有组件的computed属性, 也就是计算属性 
    visaSearchInfo: state => state.visaSearchInfo,
    travelerList: state => state.travelerList
  },
  mutations: {
    visaSearchInfo (state, payload) {
      state.visaSearchInfo = payload
    },
    travelerList (state, payload) {
      state.travelerList = payload
    },
    CLEAR_VISASEARCHINFO (state) {
      state.visaSearchInfo = initialState()
      state.travelerList = []
    }
  },
  actions: {
    /**
     * 获取受理城市
     */
    async getConsularList ({ state }) {
      if (state.visaSearchInfo.ConsularList.length > 0) return true
      
      const { data } = await VisaBookInterator.getConsularList()
      state.visaSearchInfo.ConsularList = data
    }
  }
}
export default visa